import React from 'react'

export default function Logos() {
  return (
    <div>

<div className="section-title">
          {/* <span>Services</span> */}
          <h1><strong> OUR PARTNERS </strong></h1>
          {/* <p> DISCOVER A RANGE OF INSURANCE PRODUCTS TAILORED FOR YOUR PEACE OF MIND </p> */}
        </div>
      
      <section id="clients" className="clients">
      <div className="container" data-aos="zoom-in">

        <div className="row d-flex align-items-center">

          <div className="col-lg-2 col-md-4 col-6">
            <img src="assets/img/clients/logo-1.jpg" className="img-fluid" alt="" />
          </div>

          <div className="col-lg-2 col-md-4 col-6">
            <img src="assets/img/clients/logo-2.png" className="img-fluid" alt="" />
          </div>

          <div className="col-lg-2 col-md-4 col-6">
            <img src="assets/img/clients/logo-3.png" className="img-fluid" alt="" />
          </div>

          <div className="col-lg-2 col-md-4 col-6">
            <img src="assets/img/clients/logo-4.jpg" className="img-fluid" alt="" />
          </div>

          <div className="col-lg-2 col-md-4 col-6">
            <img src="assets/img/clients/logo-5.png" className="img-fluid" alt="" />
          </div>

          <div className="col-lg-2 col-md-4 col-6">
            <img src="assets/img/clients/logo-6.png" className="img-fluid" alt="" />
          </div>

          <div className="col-lg-2 col-md-4 col-6">
            <img src="assets/img/clients/logo-7.png" className="img-fluid" alt="" />
          </div>

          <div className="col-lg-2 col-md-4 col-6">
            <img src="assets/img/clients/logo-8.png" className="img-fluid" alt="" />
          </div>

          <div className="col-lg-2 col-md-4 col-6">
            <img src="assets/img/clients/logo-9.png" className="img-fluid" alt="" />
          </div>

          <div className="col-lg-2 col-md-4 col-6">
            <img src="assets/img/clients/logo-10.png" className="img-fluid" alt="" />
          </div>
          
          <div className="col-lg-2 col-md-4 col-6">
            <img src="assets/img/clients/logo-11.png" className="img-fluid" alt="" />
          </div>

          <div className="col-lg-2 col-md-4 col-6">
            <img src="assets/img/clients/logo-12.png" className="img-fluid" alt="" />
          </div>


        </div>

      </div>
    </section>

    </div>
  )
}
